module.exports = __webpack_public_path__ + "static/media/skill5_pos_en.9e6032fb.txt";